import {
    type ActionsType
} from "../types";

export const SERVICE_EVENT_TYPES = {
    REFRESH_TOKEN: "REFRESH_TOKEN",
    GO_TO_LOGOUT: "GO_TO_LOGOUT",
    USER_UPDATED: "USER_UPDATED"
};

// export const SERVER_ADDRESS = process.env.API_URL || "http://192.168.0.10:83";
// export const API_GATEWAY_URL = process.env.API_GATEWAY_URL || "http://192.168.0.10:81";

const rawServerAddress = process.env.SERVER_ADDRESS || "http://localhost:83";
export const SERVER_ADDRESS = rawServerAddress.endsWith("/") ? rawServerAddress.slice(0, -1) : rawServerAddress;

const rawGatewayUrl = process.env.API_GATEWAY_URL || "http://localhost:81";
export const API_GATEWAY_URL = rawGatewayUrl.endsWith("/") ? rawGatewayUrl.slice(0, -1) : rawGatewayUrl;

const rawAppUrl = process.env.APP_URL || "https://app.gencmusiadkonya.org";
export const APP_URL = rawAppUrl.endsWith("/") ? rawAppUrl.slice(0, -1) : rawAppUrl;

export const SERVICE_CONFIGS: Record<ActionsType, { isWorkedWithQueue: boolean }> = {
    getAllCommercialOpportunityRequestHistories: {
        isWorkedWithQueue: true
    },
    getAllAccountDeletionRequestHistories: {
        isWorkedWithQueue: true
    },
    approveCommercialOpportunityRequest: {
        isWorkedWithQueue: true
    },
    getAllCommercialOpportunityRequests: {
        isWorkedWithQueue: true
    },
    getAllCompanyUpdateRequestHistories: {
        isWorkedWithQueue: true
    },
    getAllProfileUpdateRequestHistories: {
        isWorkedWithQueue: true
    },
    getUploadTokenForAnnouncementCover: {
        isWorkedWithQueue: true
    },
    getUploadTokenForAnnouncementPhoto: {
        isWorkedWithQueue: true
    },
    rejectCommercialOpportunityRequest: {
        isWorkedWithQueue: true
    },
    getUploadTokenForUserProfilePhoto: {
        isWorkedWithQueue: true
    },
    batchCreateDriveFolderHierarchy: {
        isWorkedWithQueue: false
    },
    getCommercialOpportunityRequest: {
        isWorkedWithQueue: true
    },
    getUploadTokenForSubEventCover: {
        isWorkedWithQueue: true
    },
    getUploadTokenForSubEventPhoto: {
        isWorkedWithQueue: true
    },
    approveAccountDeletionRequest: {
        isWorkedWithQueue: true
    },
    getAllAccountDeletionRequests: {
        isWorkedWithQueue: true
    },
    getUploadTokenForCompanyPhoto: {
        isWorkedWithQueue: true
    },
    getUploadTokenForContentPhoto: {
        isWorkedWithQueue: true
    },
    getUploadTokenForProfilePhoto: {
        isWorkedWithQueue: true
    },
    getUploadTokenForSubEventLogo: {
        isWorkedWithQueue: true
    },
    threeTGetParticipantsForAdmin: {
        isWorkedWithQueue: true
    },
    rejectAccountDeletionRequest: {
        isWorkedWithQueue: true
    },
    sendPasswordResetLinkToUsers: {
        isWorkedWithQueue: true
    },
    shareAnnouncementOnInstagram: {
        isWorkedWithQueue: true
    },
    threeTAddParticipantManually: {
        isWorkedWithQueue: true
    },
    approveCompanyUpdateRequest: {
        isWorkedWithQueue: true
    },
    approveProfileUpdateRequest: {
        isWorkedWithQueue: true
    },
    getAllCompanyUpdateRequests: {
        isWorkedWithQueue: true
    },
    getAllProfileUpdateRequests: {
        isWorkedWithQueue: true
    },
    getUploadTokenForEventCover: {
        isWorkedWithQueue: true
    },
    getUploadTokenForEventPhoto: {
        isWorkedWithQueue: true
    },
    getUploadTokenForEventLogo: {
        isWorkedWithQueue: true
    },
    getUploadTokenForNewsCover: {
        isWorkedWithQueue: true
    },
    getUploadTokenForNewsPhoto: {
        isWorkedWithQueue: true
    },
    rejectCompanyUpdateRequest: {
        isWorkedWithQueue: true
    },
    rejectProfileUpdateRequest: {
        isWorkedWithQueue: true
    },
    adminLogin: {
        isWorkedWithQueue: false
    },
    changePassword: {
        isWorkedWithQueue: false
    },
    checkVersion: {
        isWorkedWithQueue: false
    },
    createBoardMember: {
        isWorkedWithQueue: false
    },
    createOldPresident: {
        isWorkedWithQueue: false
    },
    deleteBoardMember: {
        isWorkedWithQueue: false
    },
    deleteOldPresident: {
        isWorkedWithQueue: false
    },
    getAllBoardMembers: {
        isWorkedWithQueue: false
    },
    getAllGenericInfo: {
        isWorkedWithQueue: false
    },
    getAllOldPresidents: {
        isWorkedWithQueue: false
    },
    getCities: {
        isWorkedWithQueue: false
    },
    getDepartments: {
        isWorkedWithQueue: false
    },
    getDistricts: {
        isWorkedWithQueue: false
    },
    getFaculties: {
        isWorkedWithQueue: false
    },
    getGenericInfoByKey: {
        isWorkedWithQueue: false
    },
    getInitialConfigs: {
        isWorkedWithQueue: false
    },
    getPresident: {
        isWorkedWithQueue: false
    },
    getProfile: {
        isWorkedWithQueue: false
    },
    getUniversities: {
        isWorkedWithQueue: false
    },
    refreshToken: {
        isWorkedWithQueue: false
    },
    threeTGenerateSeatingPlan: {
        isWorkedWithQueue: true
    },
    updateBoardMember: {
        isWorkedWithQueue: false
    },
    updateGenericInfo: {
        isWorkedWithQueue: false
    },
    updateOldPresident: {
        isWorkedWithQueue: false
    },
    updatePresident: {
        isWorkedWithQueue: false
    },
    cancelSubEvent: {
        isWorkedWithQueue: true
    },
    changeMail: {
        isWorkedWithQueue: true
    },
    createAnnouncement: {
        isWorkedWithQueue: true
    },
    createCompanyForAdmin: {
        isWorkedWithQueue: true
    },
    createDriveFolder: {
        isWorkedWithQueue: true
    },
    createDriveRecord: {
        isWorkedWithQueue: true
    },
    createEvent: {
        isWorkedWithQueue: true
    },
    createForm: {
        isWorkedWithQueue: true
    },
    createNews: {
        isWorkedWithQueue: true
    },
    createNewsCategory: {
        isWorkedWithQueue: true
    },
    createSubEvent: {
        isWorkedWithQueue: true
    },
    createSystemLocale: {
        isWorkedWithQueue: true
    },
    deleteAnnouncement: {
        isWorkedWithQueue: true
    },
    deleteContactForm: {
        isWorkedWithQueue: true
    },
    deleteDriveFile: {
        isWorkedWithQueue: true
    },
    deleteDriveFolder: {
        isWorkedWithQueue: true
    },
    deleteEvent: {
        isWorkedWithQueue: true
    },
    deleteForm: {
        isWorkedWithQueue: true
    },
    deleteNews: {
        isWorkedWithQueue: true
    },
    deleteNewsCategory: {
        isWorkedWithQueue: true
    },
    deleteSentNotification: {
        isWorkedWithQueue: true
    },
    deleteSubEvent: {
        isWorkedWithQueue: true
    },
    deleteSystemLocale: {
        isWorkedWithQueue: true
    },
    deleteUser: {
        isWorkedWithQueue: true
    },
    duplicateFormForAdmin: {
        isWorkedWithQueue: true
    },
    editEvent: {
        isWorkedWithQueue: true
    },
    editForm: {
        isWorkedWithQueue: true
    },
    editSubEvent: {
        isWorkedWithQueue: true
    },
    endEventApplication: {
        isWorkedWithQueue: true
    },
    executeCommand: {
        isWorkedWithQueue: true
    },
    finishEvent: {
        isWorkedWithQueue: true
    },
    getAllAnnouncements: {
        isWorkedWithQueue: true
    },
    getAllCompaniesForAdmin: {
        isWorkedWithQueue: true
    },
    getAllContactForms: {
        isWorkedWithQueue: true
    },
    getAllDriveFiles: {
        isWorkedWithQueue: true
    },
    getAllDriveFolders: {
        isWorkedWithQueue: true
    },
    getAllEventsForAdmin: {
        isWorkedWithQueue: true
    },
    getAllFormsForAdmin: {
        isWorkedWithQueue: true
    },
    getAllNews: {
        isWorkedWithQueue: true
    },
    getAllNewsCategories: {
        isWorkedWithQueue: true
    },
    getAllSentMails: {
        isWorkedWithQueue: true
    },
    getAllSentNotifications: {
        isWorkedWithQueue: true
    },
    getAllSubEventsForAdmin: {
        isWorkedWithQueue: true
    },
    getAllSystemLocales: {
        isWorkedWithQueue: true
    },
    getAllUsersForAdmin: {
        isWorkedWithQueue: true
    },
    getAnnouncementById: {
        isWorkedWithQueue: true
    },
    getCompanyForAdmin: {
        isWorkedWithQueue: true
    },
    getCompanyUpdateRequest: {
        isWorkedWithQueue: true
    },
    getDashboardOverview: {
        isWorkedWithQueue: true
    },
    getDriveItems: {
        isWorkedWithQueue: true
    },
    getEventForAdmin: {
        isWorkedWithQueue: true
    },
    getFormAnswersForAdmin: {
        isWorkedWithQueue: true
    },
    getFormForAdmin: {
        isWorkedWithQueue: true
    },
    getNewsById: {
        isWorkedWithQueue: true
    },
    getPositions: {
        isWorkedWithQueue: true
    },
    getProfileUpdateRequest: {
        isWorkedWithQueue: true
    },
    getSectors: {
        isWorkedWithQueue: true
    },
    getSentMailById: {
        isWorkedWithQueue: true
    },
    getSentNotificationById: {
        isWorkedWithQueue: true
    },
    getSubEventForAdmin: {
        isWorkedWithQueue: true
    },
    getUploadTokenForDrive: {
        isWorkedWithQueue: true
    },
    getUserForAdmin: {
        isWorkedWithQueue: true
    },
    logout: {
        isWorkedWithQueue: true
    },
    markContactFormAsRead: {
        isWorkedWithQueue: true
    },
    me: {
        isWorkedWithQueue: true
    },
    registerUser: {
        isWorkedWithQueue: true
    },
    removeSubEventPhoto: {
        isWorkedWithQueue: true
    },
    resizeLegacyImages: {
        isWorkedWithQueue: true
    },
    resolveContactForm: {
        isWorkedWithQueue: true
    },
    sendCustomMail: {
        isWorkedWithQueue: true
    },
    sendCustomNotification: {
        isWorkedWithQueue: true
    },
    shareNewsOnInstagram: {
        isWorkedWithQueue: true
    },
    startEvent: {
        isWorkedWithQueue: true
    },
    startEventApplication: {
        isWorkedWithQueue: true
    },
    switchOrganization: {
        isWorkedWithQueue: true
    },
    threeTFinish: {
        isWorkedWithQueue: true
    },
    threeTGetEventRound: {
        isWorkedWithQueue: true
    },
    threeTStartRound: {
        isWorkedWithQueue: true
    },
    toggleFormStatusForAdmin: {
        isWorkedWithQueue: true
    },
    updateAnnouncement: {
        isWorkedWithQueue: true
    },
    updateCompanyForAdmin: {
        isWorkedWithQueue: true
    },
    updateDriveFile: {
        isWorkedWithQueue: true
    },
    updateDriveFolder: {
        isWorkedWithQueue: true
    },
    updateNews: {
        isWorkedWithQueue: true
    },
    updateNewsCategory: {
        isWorkedWithQueue: true
    },
    updateProfile: {
        isWorkedWithQueue: true
    },
    updateSystemLocale: {
        isWorkedWithQueue: true
    },
    updateUser: {
        isWorkedWithQueue: true
    }
};
